<div>
  <div>
    <div
      class="flex items-center justify-between border-b border-mbaza-gray-light pb-4 mb-6"
    >
      <img [src]="ASSET_CONSTANTS.I_unopen_bell" alt="bell" class="w-6 h-6" />
      <span class="font-black">Notifications</span>
      <div
        (click)="closeDrawer()"
        (keydown.enter)="closeDrawer()"
        (keydown.space)="closeDrawer()"
        tabindex="0"
        role="button"
        [attr.aria-label]="'Close notifications'"
      >
        <img
          [src]="ASSET_CONSTANTS.I_cancel"
          alt="close"
          class="w-6 h-6 grayscale"
        />
      </div>
    </div>
  </div>
  <!-- Notification list -->
  @for (notification of notifications; track notification.id) {

  <div
    class="flex gap-6 pb-6"
    (click)="openNotification(notification)"
    (keydown.enter)="openNotification(notification)"
    (keydown.space)="openNotification(notification)"
    tabindex="0"
    role="button"
    [attr.aria-label]="'Open notification'"
  >
    <!-- if read is false, show unopen bell -->
    @if (!notification.read) {
    <img [src]="ASSET_CONSTANTS.I_bell_filled" alt="bell" class="w-6 h-6" />
    } @else {
    <img [src]="ASSET_CONSTANTS.I_bell" alt="bell" class="w-6 h-6" />
    }
    <div>
      <span class="text-mbaza-gray text-xs font-extralight">{{
        notification.createdAt | date : "dd MMM yyyy - HH:mm a"
      }}</span>
      @if (notification.content.includes('Invited to a case')) {
      <div>
        <span class="text-bold">{{ notification.senderName }} </span>
        <span class="text-mbaza-gray">invited you to a case #{{ notification.complaintapplicationNumber }}</span>
      </div>
      } @else {
      <div>
        <span class="text-bold">{{ notification.senderName }} </span>
        <span class="text-mbaza-gray">{{ notification.content }}</span>
      </div>
      }
    </div>
  </div>
  }
</div>
